import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';
import { zodResolver } from '@hookform/resolvers/zod';
import { omit } from 'lodash';
import { Form } from '../../shared/components/Form';
import { SMSTemplateSchema } from '../../shared/types';
import { route } from '../../shared/utils';
import SMSTemplateDetailHeader from './components/SMSTemplateDetailHeader';
import TemplateDetailForm from './components/TemplateDetailForm';
import useCreateSMSTemplate from './hooks/useCreateSMSTemplate';
import useGetSMSTemplateById from './hooks/useGetSMSTemplateById';
import useUpdateSMSTemplateById from './hooks/useUpdateSMSTemplateById';
const SMSTemplateDetailPage = () => {
    const isNew = useParams().id === 'new';
    const { data: templateDetail, isLoading } = useGetSMSTemplateById(isNew ? '' : useParams().id || '');
    const navigate = useNavigate();
    const { mutate: createSMSTemplate, isPending: isCreatingSMSTemplate } = useCreateSMSTemplate();
    const { mutate: updateSMSTemplate, isPending: isUpdatingSMSTemplate } = useUpdateSMSTemplateById();
    const method = useForm({
        resolver: zodResolver(SMSTemplateSchema),
        defaultValues: {
            name: '',
            content: '',
            description: '',
            notification_types: '',
            // TODO: when COMS-424 is done, uncomment the following line
            //      notification_types: [],
            active: true,
            is_tcpa: true,
        },
    });
    const { formState: { isDirty }, trigger, reset, handleSubmit, } = method;
    useEffect(() => {
        if (templateDetail) {
            reset({
                ...templateDetail,
                notification_types: templateDetail.notification_types[0],
                active: templateDetail.status === 'A',
                is_tcpa: templateDetail.is_tcpa,
            });
        }
    }, [templateDetail, reset]);
    const onSubmit = (data) => {
        if (isNew) {
            createSMSTemplate({
                ...data,
                notification_types: [data.notification_types],
                // TODO: when COMS-424 is done, uncomment the following line
                //        notification_types: data.notification_types.map((type) => type.value),
            }, {
                onSuccess: () => {
                    navigate(route('/templates/sms'));
                },
            });
        }
        else {
            updateSMSTemplate({
                id: templateDetail?.id || '',
                data: omit(data, ['notification_types', 'active']),
            });
        }
    };
    const triggerSubmit = async () => {
        const isValid = await trigger();
        if (isValid) {
            await handleSubmit(onSubmit)();
        }
    };
    if (isLoading)
        return null;
    return (_jsx(Form, { ...method, children: _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "form", children: [_jsx(SMSTemplateDetailHeader, { title: isNew ? 'New template title' : templateDetail?.name || '', isDirty: isDirty, isLoading: isCreatingSMSTemplate || isUpdatingSMSTemplate, onSubmit: triggerSubmit }), _jsx(TemplateDetailForm, { isNew: isNew })] }) }));
};
export default SMSTemplateDetailPage;
